const iqProd = false;
const bdtts = false;

let account_url = process.env.VUE_APP_ACCOUNT_URL;
let socket_url = process.env.VUE_APP_SOCKET_URL;
let vsocket_url = process.env.VUE_APP_VSOCKET_URL;
const download_url = process.env.VUE_APP_DOWNLOAD_URL;
const eaAccessUrl = "/t/index.html";
let isEarlyAccessEnabled = false;

if (["webapp", "test"].includes(process.env.VUE_APP_ENV)) {
  account_url = localStorage.account_url || account_url;
  socket_url = localStorage.socket_url || socket_url;
  vsocket_url = localStorage.vsocket_url || vsocket_url;
}

if (["webapp", "test", "studio"].includes(process.env.VUE_APP_ENV)) {
  // 存在灰度环境的服务
  isEarlyAccessEnabled = true;
}

localStorage.socket_url = socket_url;
localStorage.vsocket_url = vsocket_url;
localStorage.account_url = account_url;

let os = "windows";
const ua = navigator.userAgent.toLowerCase();
if (ua.indexOf("windows") !== -1) {
  os = "windows";
} else if (ua.indexOf("macintosh") !== -1) {
  os = "mac";
} else if (ua.indexOf("linux") !== -1) {
  os = "linux";
}

let isSupportedBrowser = false;
let errorType = "";
const isMobile = /Android|webOS|iPhone|iPad|BlackBerry/i.test(ua);
if (isMobile) {
  isSupportedBrowser = false;
  errorType = "DEVICE";
} else {
  const matches = ua.match(/(chrome)\/(\d+)/);
  if (!matches) {
    isSupportedBrowser = false;
    errorType = "BROWSER";
  } else {
    const blackList = ["opr", "qqbrowser", "360se", "se 2.x", "firefox"];

    if (blackList.some((v) => ua.includes(v))) {
      isSupportedBrowser = false;
      errorType = "BROWSER";
    } else if (matches[2] < 86) {
      isSupportedBrowser = false;
      errorType = "VERSION";
    } else {
      isSupportedBrowser = true;
    }
  }
}

export default {
  iqProd: iqProd,
  bdtts: bdtts,
  os: os,
  account_url: account_url,
  socket_url: socket_url,
  vsocket_url: vsocket_url,
  download_url: download_url,
  eaAccessUrl: eaAccessUrl,
  isEarlyAccessEnabled: isEarlyAccessEnabled,
  isSupportedBrowser: isSupportedBrowser,
  errorType: errorType,
  rtcOffline: false,
  release: process.env.VUE_APP_ENV == "studio",
  video_screen: {
    width: 640,
    height: 360,
    playerWidth: 640,
    playerHeight: 360,
  },
};
